import React from 'react';
import Layout from '@/common/Layout';
import WastageMaterialsPage from './components/WastageMaterialsPage';

const WastageMaterials = () => {
  return (
    <>
      <Layout sider={false}>
        <WastageMaterialsPage />
      </Layout>
    </>
  );
};

export default WastageMaterials;
